import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
} from 'shared/constants/ActionTypes';
import { setAuthToken } from './index';
import axios from 'axios';
import geturl from '@common/fileUrl';
import Api from '@api';
import { permissionCheck } from 'redux/actions';
import { setCompanyName } from 'redux/actions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { connect, disconnect } from '@common/socketUtil';

const JWTAuthContext = createContext();
const JWTAuthActionsContext = createContext();

export const useJWTAuth = () => useContext(JWTAuthContext);

export const useJWTAuthActions = () => useContext(JWTAuthActionsContext);

const JWTAuthAuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [firebaseData, setJWTAuthData] = useState({
    user: null,
    isAuthenticated: false,
    isLoading: true,
  });

  const dispatch = useDispatch();

  const getUserPermissions = (corporateId, userRole) => {
    const resolvedRole =
      userRole == 'MANAGER'
        ? 'ROSTERADMIN'
        : userRole == 'TANENTADMIN' || userRole == 'SUPERADMIN'
        ? 'CORPORATEADMIN'
        : userRole;

    return axios
      .get(
        `${Api.baseUri}/user-reg/user-permission/get-all-user-permission-by-corpId/${corporateId}/${resolvedRole}`
      )
      .then((res) => {
        dispatch(permissionCheck(res?.data?.data?.permissions || []));
      })
      .catch(() => {});
  };

  const getCorporateName = () => {
    axios
      .get(
        `${Api.baseUri}/user-reg/siteoffice-reg/corporate?page=0&size=100&officeName=null`
      )
      .then((res) => {
        if (res?.data?.status === 200) {
          const office = res?.data?.data?.body?.['SiteOffice List'][0];
          dispatch(
            setCompanyName(`${office?.companyName}++${office?.officeName}`)
          );
        }
      })
      .catch(() => {});
  };

  const fetchCompanyLogo = (tenantId) => {
    if (tenantId) {
      axios
        .get(`${Api.onBoardTenant?.list}/${tenantId}`)
        .then((res) => {
          if(res?.data?.data?.companyLogoDoc) {
            geturl.getRealUrl(res?.data?.data?.companyLogoDoc, 'COMPANY_LOGO');
          }
        })
        .catch(() => {});
    }
  };

  async function setTokenData(data) {
    const tempo = { ...data?.data };
    const checkSwitch = localStorage.getItem('switched');

    if (tempo?.userRoles?.length) tempo.isManagerKey = 'YES';
    
    let corporateDetails = {}
    if (tempo.corporateId) {
      try {
        const res = await axios.get(
          `${Api.baseUri}/user-reg/corporate-reg/${tempo?.corporateId}`
        );
        corporateDetails.corporateName = res?.data?.data?.companyName;
        corporateDetails.corporateCode = res?.data?.data?.companyCode;
        if(tempo.userRoleName == 'CORPORATEADMIN') {
          tempo.contactName = `${res?.data?.data?.contactPersonFirstName || ''} ${
            res?.data?.data?.contactPersonLastName || ''
          }`;
        }
      } catch {}
    }

    if ((tempo.userRoleName === 'EMPLOYEE' || tempo.userRoleName === 'CORPORATEADMIN' || tempo.userRoleName === 'TANENTADMIN') && checkSwitch) {
      const roleToSwitch =
        checkSwitch == 'MANAGER' ? 'ROSTERADMIN' : checkSwitch;
      const response = await axios.post(Api?.auth?.switchRole, {
        authToken: localStorage.getItem('token'),
        userRole: roleToSwitch,
      });

      if (response?.data?.data?.token)
        tempo.token = response?.data?.data?.authToken;

      localStorage.setItem('token', response?.data?.data?.authToken);
      localStorage.setItem('refresh-token', response?.data?.data?.refreshToken);
      localStorage.setItem('userRole', response?.data?.data?.userRole);
      localStorage.removeItem('switched');

      if (response?.data?.data?.authToken)
        setAuthToken(response?.data?.data?.authToken);
      if (response?.data?.data?.userRole)
        tempo.userRole = response?.data?.data?.userRole;
      if (response?.data?.data?.profileId)
        tempo.profileId = response?.data?.data?.profileId;
    }

    let theme = {};
    if (data?.data?.tanentId) {
      try {
        const res = await axios.get(
          `${Api.baseUri}/user-reg/tenant-reg/${data?.data?.tanentId}`
        );
        localStorage.setItem(
          'contactPersonFirstName',
          res?.data?.data?.contactPersonFirstName
        );
        theme.theme = res?.data?.data?.theme || { bgColor: '#10234e' };
      } catch {}
    }

    await getUserPermissions(data?.data?.corporateId, tempo.userRole);

    if (tempo?.userRole == 'ROSTERADMIN') tempo.userRole = 'MANAGER';

    const tenantId =
      tempo.userRole == 'TENANTADMIN' ? tempo?.profileId : tempo.tanentId;
    getCorporateName();
    fetchCompanyLogo(tenantId);

    setJWTAuthData({
      user: { ...tempo, ...theme, ...corporateDetails },
      isLoading: false,
      isAuthenticated: true,
    });
  }

  useEffect(() => {
    const getAuthUser = async () => {
      const token = localStorage.getItem('token');
      const isSwitch = localStorage.getItem('switched');

      if (!token) {
        setJWTAuthData({
          user: undefined,
          isLoading: false,
          isAuthenticated: false,
        });
        return;
      }

      if (!isSwitch) setAuthToken(token);

      try {
        const { data } = await axios.post(Api.auth.verifyToken, {
          authToken: token,
        });

        if (data.status === 200) {
          if (data.data.userRole != 'SUPERADMIN')
            data.data.isImpersonate = null;

          await setTokenData(data);

          // axios
          //   .get(Api?.token?.tokenapi)
          //   .then((result) => {
          //     localStorage.setItem('mappl_access_token', result?.data?.data);
          //   })
          //   .catch(() => {});
        } else {
          setJWTAuthData({
            user: undefined,
            isLoading: false,
            isAuthenticated: false,
          });
          localStorage.clear();
          window.location.reload();
        }
      } catch {
        setJWTAuthData({
          user: undefined,
          isLoading: false,
          isAuthenticated: false,
        });
        localStorage.clear();
        window.location.reload();
      }
    };

    getAuthUser();
  }, []);

  // Setup WebSocket connections when user is authenticated
  useEffect(() => {
    if (firebaseData.isAuthenticated && firebaseData.user) {
      setupSocket(firebaseData.user);
    }
  }, [firebaseData.isAuthenticated, firebaseData.user]);

  // Fetch public IP
  // const getPublicIP = async () => {
  //   try {
  //     const { data } = await axios.get('https://api.ipify.org?format=json');
  //     return data?.ip || '';
  //   } catch (err) {
  //     console.error('Failed to get IP:', err);
  //     return '';
  //   }
  // };

  // Build login request payload
  const buildLoginRequest = ({
    type,
    otp,
    uid,
    loginType,
    // sysip,
    // deviceType,
  }) => {
    if (type === 'sso') {
      return {
        uri: Api.auth.ssoUserLoginMail,
        requestData: {
          ssoToken: otp,
          ssoName: loginType,
          ssoEmail: uid,
          // ipAddress: sysip,
          // deviceType,
        },
      };
    } else if (type === 'password') {
      return {
        uri: Api.auth.loginWithPassword,
        requestData: { loginId: uid, userPassword: otp },
      };
    }
    return {
      uri: Api.auth.verifyOTP,
      requestData: {
        userId: uid,
        otp,
        // ipAddress: sysip,
        // deviceType,
      },
    };
  };

  // Handle successful login
  const handleSuccessfulLogin = async (userData) => {
    // Store tokens
    localStorage.setItem('token', userData?.authToken);
    localStorage.setItem('refresh-token', userData?.refreshToken);
    setAuthToken(userData?.authToken);
    axios.defaults.headers['vtt_user_signature'] = userData?.authToken;

    // Normalize user role
    if (userData.userRole !== 'SUPERADMIN') userData.isImpersonate = null;
    if (userData?.userRole === 'ROSTERADMIN') {
      userData.userRole = 'MANAGER';
      localStorage.setItem('userRole', 'MANAGER');
    } else {
      localStorage.setItem('userRole', userData?.userRole);
    }

    localStorage.removeItem('switched');

    // Initialize socket connection
    setupSocket(userData);

    // Fetch other required data (token, permissions, company info, theme)
    await Promise.all([
      // fetchMapplToken(),
      fetchPermissions(userData),
      fetchCompanyInfo(userData),
      fetchTheme(userData),
    ]);

    // Set final auth state
    setJWTAuthData({
      user: userData,
      isAuthenticated: true,
      isLoading: false,
    });

    dispatch({ type: FETCH_SUCCESS });

    if (userData.userRole === 'CORPORATEADMIN') {
      window.location.reload();
    }
  };

  // Handle login failure
  const handleLoginFailure = (message, loginType) => {
    setJWTAuthData({
      ...firebaseData,
      isAuthenticated: false,
      isLoading: false,
    });
    dispatch({
      type: FETCH_ERROR,
      payload: message || 'Something went wrong',
    });
    localStorage.clear();
    if (loginType === 'ciscoDuo') {
      navigate('/home');
    }
  };

  // Socket setup
  const setupSocket = (userData) => {
    if (userData?.userRole) {
      let role = userData.userRole;
      let profileId = null;
      if (role === 'CORPORATEADMIN' || role === 'SUPERADMIN' || role === 'TENANTADMIN') {
        profileId = userData?.corporateId;
      } else if (role === 'VENDOR') {
        profileId = userData?.profileId;
      }

      if (profileId) {
        connect(role, profileId);
        console.log('Root-level WebSocket connections established for:', role, profileId);
      }
      else {
        console.log("WebSocket connection not established: profileId not found");
        return;
      }
    }
  };

  // Fetch Mappl token
  const fetchMapplToken = async () => {
    try {
      const result = await axios.get(Api?.token?.tokenapi);
      localStorage.setItem('mappl_access_token', result?.data?.data);
    } catch (e) {
      console.error('Failed to fetch Mappl token', e);
    }
  };

  // Fetch permissions
  const fetchPermissions = async (userData) => {
    const roleForPermission =
      userData?.userRole === 'MANAGER' ? 'ROSTERADMIN' : userData?.userRole;
    const { data } = await axios.get(
      `${Api.baseUri}/user-reg/user-permission/get-all-user-permission-by-corpId/${userData?.corporateId}/${roleForPermission}`
    );
    dispatch(permissionCheck(data?.data?.permissions || []));
  };

  // Fetch company info
  const fetchCompanyInfo = async (userData) => {
    const tenId =
      userData.userRole === 'TENANTADMIN'
        ? userData?.profileId
        : userData.tanentId || userData.corporateId;

    const siteRes = await axios.get(
      `${Api.baseUri}/user-reg/siteoffice-reg/corporate?page=0&size=100&officeName=null`
    );
    if (siteRes?.data?.status === 200) {
      const site = siteRes?.data?.data?.body?.['SiteOffice List'][0];
      dispatch(setCompanyName(`${site?.companyName}++${site?.officeName}`));
    }

    if (tenId) {
      const logoRes = await axios.get(Api.onBoardTenant?.list + '/' + tenId);
      if(logoRes?.data?.data?.companyLogoDoc) {
        geturl.getRealUrl(logoRes?.data?.data?.companyLogoDoc, 'COMPANY_LOGO');
      }
    }
  };

  // Fetch and apply theme
  const fetchTheme = async (userData) => {
    if (userData?.tanentId) {
      const themeRes = await axios.get(
        `${Api.baseUri}/user-reg/tenant-reg/${userData?.tanentId}`
      );
      const themeData = themeRes?.data?.data?.theme || {
        bgColor: '#10234e',
        btnColor: 'primary',
        hoverColor: 'black',
        fontColor: 'white',
      };
      setJWTAuthData({
        user: { ...userData, theme: themeData },
        isAuthenticated: true,
        isLoading: false,
      });
    }
  };

  const signInUser = async ({ type, otp, uid, loginType, on428 }) => {
    dispatch({ type: FETCH_START });

    try {
      // Detect device type
      // const width = window.innerWidth;
      // const deviceType =
      //   width <= 480 ? 'Mobile' : width <= 1024 ? 'Tablet' : 'Desktop';

      // Fetch public IP
      // const sysip = await getPublicIP();

      // Build request payload and endpoint
      const { uri, requestData } = buildLoginRequest({
        type,
        otp,
        uid,
        loginType,
        // sysip,
        // deviceType,
      });

      if (type !== 'sso') {
        localStorage.setItem('userID', uid);
      }

      let data;

      // Call login API
      if (loginType === 'ciscoDuo') {
        // Assuming requestData becomes query params for GET
        const response = await axios.get(
          `${Api.auth.ciscoSSOLogin}?code=${otp}&platform=web`
        );
        data = response.data;
      } else {
        const response = await axios.post(uri, requestData);
        data = response.data;
      }

      // Handle 428 — password not yet set, redirect to set-password flow
      if (data?.status === 428) {
        dispatch({ type: FETCH_SUCCESS });
        if (on428) on428();
        return;
      }

      // // Handle login success
      if (data?.status === 200 && data?.data?.userRole !== 'DRIVER') {
        await handleSuccessfulLogin(data.data);
      } else {
        handleLoginFailure(data?.message, loginType);
      }
    } catch (error) {
      handleLoginFailure(
        error?.response?.data?.message || 'Something went wrong.',
        loginType
      );
    }
  };

  // const signUpUser = async ({ name, email, password }) => {
  //   dispatch({ type: FETCH_START });
  //   try {
  //     const { data } = await jwtAxios.post('users', { name, email, password });
  //     localStorage.setItem('token', data.token);
  //     setAuthToken(data.token);
  //     const res = await jwtAxios.get('/auth');
  //     setJWTAuthData({
  //       user: res.data,
  //       isAuthenticated: true,
  //       isLoading: false,
  //     });
  //     dispatch({ type: FETCH_SUCCESS });
  //   } catch (error) {
  //     setJWTAuthData({
  //       ...firebaseData,
  //       isAuthenticated: false,
  //       isLoading: false,
  //     });
  //
  //     dispatch({
  //       type: FETCH_ERROR,
  //       payload: error?.response?.data?.error || 'Something went wrong',
  //     });
  //   }
  // };

  const logout = async () => {
    toast.success('You logged out successfully', {
      toastId: 'logout-success',
    });

    // Clean up all WebSocket connections
    disconnect();

    localStorage.clear();
    setAuthToken();
    setJWTAuthData({
      user: null,
      isLoading: false,
      isAuthenticated: false,
    });
    window.location.reload();
  };

  let isRefreshing = false;
  let failedQueue = [];

  function processQueue(error, token = null) {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });
    failedQueue = [];
  }

  const handleRefreshToken = async (originalRequest) => {
    const refresh_token = localStorage.getItem('refresh-token');
    const instance = axios.create();
    delete instance?.defaults?.headers?.common['vtt_user_signature'];
    if (!refresh_token) {
      logout();
      return Promise.reject(new Error('No refresh token available'));
    }

    try {
      const response = await instance.post(
        `${Api.auth.refreshToken}?refreshToken=${refresh_token}`
      );

      // Fix: Access nested data property
      const { authToken, refreshToken } = response.data.data || response.data;

      if (!authToken) {
        throw new Error('No auth token received from refresh');
      }

      // Update axios headers and local storage
      axios.defaults.headers['vtt_user_signature'] = authToken;
      setAuthToken(authToken);
      localStorage.setItem('token', authToken);

      if (refreshToken) {
        localStorage.setItem('refresh-token', refreshToken);
      }

      processQueue(null, authToken);

      // Retry the original request with new token
      if (originalRequest) {
        originalRequest.headers['vtt_user_signature'] = authToken;
        return axios(originalRequest);
      }

      return Promise.resolve(authToken);
    } catch (err) {
      console.error('Token refresh failed:', err);
      processQueue(err, null);
      isRefreshing = false;
      logout();
      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  };

  // Response interceptor: refresh logic
  axios.interceptors.response.use(
    async (response) => {
      const errorCode = response?.data?.status;
      const originalRequest = response.config;

      // Check if token expired (status 511)
      if (errorCode === 511 && !originalRequest._retry) {
        originalRequest._retry = true; // Mark request as retried to prevent infinite loops

        if (isRefreshing) {
          // If already refreshing, queue this request
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers['vtt_user_signature'] = token;
              return axios(originalRequest);
            })
            .catch((err) => Promise.reject(err));
        }

        // Start refresh process
        isRefreshing = true;
        return handleRefreshToken(originalRequest);
      }

      return response;
    },
    async (error) => {
      const originalRequest = error.config;

      // Handle 401 unauthorized errors as well
      if (error.response?.status === 401 && !originalRequest?._retry) {
        originalRequest._retry = true;

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers['vtt_user_signature'] = token;
              return axios(originalRequest);
            })
            .catch((err) => Promise.reject(err));
        }

        isRefreshing = true;
        try {
          return await handleRefreshToken(originalRequest);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );

  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['vtt_user_signature'] = token;
    }
    return config;
  });

  return (
    <JWTAuthContext.Provider
      value={{
        ...firebaseData,
      }}
    >
      <JWTAuthActionsContext.Provider
        value={{
          // signUpUser,
          signInUser,
          logout,
        }}
      >
        {children}
      </JWTAuthActionsContext.Provider>
    </JWTAuthContext.Provider>
  );
};
export default JWTAuthAuthProvider;

JWTAuthAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
